module.exports = __webpack_public_path__ + "static/media/carousel1.e62ab737.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousel/carousel1.jpg
// module id = 453
// module chunks = 16